<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Identificação do paciente"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.nome"
                        disabled
                        label="Nome"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.nomeSocial"
                        disabled
                        label="Nome social"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.dataNascimento"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.idade"
                        disabled
                        label="Idade"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.prontuario"
                        disabled
                        label="Prontuário municipal"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :mask="mask.cpf"
                        :value="form.paciente.cpf"
                        disabled
                        label="CPF"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.cns"
                        disabled
                        label="CNS"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.nomeMae"
                        disabled
                        label="Nome da mãe"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.telefone"
                        disabled
                        label="Telefone"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.municipioUf"
                        disabled
                        label="Município / Estado"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.unidadeReferencia"
                        disabled
                        label="Unidade de referência"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.classificacao"
                        disabled
                        label="Classificação"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.validadeFim"
                        disabled
                        label="Validade do cadastro"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <FormBusca
            :additionals="additionals"
            :form="form"
            :model="model"
            :paciente-id="id"
            @cleaned="agendamentos = $event"
            @searched="agendamentos = $event"
            ref="FormBusca"
        />

        <ListBusca
            :agendamentos="agendamentos"
            @canceled="$refs.FormBusca.search()"
            @deleted="$refs.FormBusca.search()"
            @updated="$refs.FormBusca.search()"
        />
    </div>
</template>

<script>
// Components.
import FormBusca from './components/busca/Form'
import ListBusca from './components/busca/List'

// Mixins.
import {error, mask, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        FormBusca,
        ListBusca,
    },
    created() {
        this.repositories = {
            agendamentoRetroativo: this.getConectaSusRepository('ambulatorio.agendamentoRetroativo'),
        }
    },
    data: () => ({
        additionals: null,
        agendamentos: [],
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.agendamentoRetroativo.create(this.id, this.camelObjectKeysToSnakeRecursive({origem: 'busca'}))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.$emit('loaded', {additionals: this.additionals, form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, mask, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: [Number, String], required: true},
    },
}
</script>